<script setup>
import { ref, computed, onMounted, onUnmounted } from 'vue';

const isDark = ref(document.documentElement.classList.contains('dark'));

const observer = new MutationObserver(() => {
  isDark.value = document.documentElement.classList.contains('dark');
});

onMounted(() => {
  observer.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['class'],
  });
});

onUnmounted(() => observer.disconnect());

const calendarSrc = computed(() => {
  const base =
    'https://calendar.google.com/calendar/embed?src=digincrease%40gmail.com&ctz=America%2FArgentina%2FBuenos_Aires&showTitle=0&showNav=1&showDate=1&showPrint=0&showTabs=1&showCalendars=0&showTz=0';
  return isDark.value ? base + '&color=%2376b658' : base;
});
</script>

<template>
  <div class="pt-6 pb-12">
    <div class="flex items-center justify-between mb-8">
      <div>
        <h1 class="text-xl font-semibold text-n-slate-12">Citas y Agendas</h1>
        <p class="text-sm text-n-slate-10 mt-0.5">
          Calendario de citas y reuniones — Google Calendar
        </p>
      </div>
      <a
        href="https://calendar.google.com"
        target="_blank"
        rel="noopener"
        class="flex items-center gap-1.5 text-sm text-n-slate-11 hover:text-n-brand transition-colors"
      >
        <span class="i-lucide-external-link size-4" />
        Abrir en Google Calendar
      </a>
    </div>

    <div
      class="rounded-xl border border-n-weak overflow-hidden"
      :class="isDark ? 'bg-n-surface-2' : 'bg-white'"
    >
      <div v-if="isDark" class="relative">
        <div
          class="absolute inset-0 pointer-events-none z-10"
          style="background: rgba(0,0,0,0.08);"
        />
        <iframe
          :src="calendarSrc"
          class="w-full"
          style="height: 720px; border: 0; filter: invert(0.88) hue-rotate(180deg);"
          frameborder="0"
          scrolling="no"
          title="Calendario de Citas"
        />
      </div>
      <iframe
        v-else
        :src="calendarSrc"
        class="w-full"
        style="height: 720px; border: 0;"
        frameborder="0"
        scrolling="no"
        title="Calendario de Citas"
      />
    </div>

    <p class="text-xs text-n-slate-8 mt-3 text-center">
      Las citas se gestionan desde Google Calendar. Los cambios se sincronizan automaticamente.
    </p>
  </div>
</template>
